import React from "react";
import { ParticipantFileStatusCode } from "../../../../../types/components";
import { PDFFileIcon } from "../../../../atom/icons/PDFFileIcon";
import { XMLFileIcon } from "../../../../atom/icons/XMLFileIcon";
import { FileStatus } from "../../../../atom/FileStatus";

// TODO: better fileType typing?
export interface DocumentItemProps {
  title: string;
  description: string;
  fileType: string;
  status: ParticipantFileStatusCode;
}

export const DocumentItem = ({ title, status, fileType }: DocumentItemProps) => {
  return (
    <>
      <div className="flex flex-row justify-between">
        <div className="flex items-center gap-4">
          {fileType === "pdf" ? <PDFFileIcon /> : <XMLFileIcon />}
          <p className="text-[18px] font-medium leading-[21.6px] tracking-[0.2px] text-black max-w-[434px]">
            {title}
          </p>
        </div>
        <div className="flex-shrink-0 pr-1">
          <FileStatus code={status} />
        </div>
      </div>
    </>
  );
};
